import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import  DeleteConfirmDialog  from './DeleteConfirmDialog';
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { axiosAuth_ASSET_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import './AdminPages.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const AssetImportAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // ### TESTING
  const [assetImportAttrs, setAssetImportAttrs] = useState({});

  const [errMsgImportAsset, setErrMsgImportAsset] = useState('');
  const [errMsg,            setErrMsg]            = useState('');

  // UI Functions

  // Initialize state
  useEffect(() => {

    if (props) {
      setAssetImportAttrs(props.objDetails);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const fetchAssetImportAttrs = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_ASSET_MGMT_API.get("asset-import-reqs/" + id);

        resolve(res.data);

        if (res.status === 200) {
          setAssetImportAttrs(res.data[0]);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  // Import Confirm Dialog stuff

  const [showCancelImportConfirmDialog, setShowCancelImportConfirmDialog] = useState(false);
  const [errMsgImportConfirm,           ]                                 = useState('');

  // --- Cancel Existing Request ---

  function handleCancelImportRequest() {
    setShowCancelImportConfirmDialog(true);
  }

  function handleCancelImportRequestCancel() {
    setShowCancelImportConfirmDialog(false);
  }

  function handleCancelImportRequestSubmit() {

    // Reserved for future needs for any parameters.
    let reqBody = {};

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_ASSET_MGMT_API.delete("asset-import-reqs/" + assetImportAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsgImportAsset('');
          setShowCancelImportConfirmDialog(false);

          // Update status
          fetchAssetImportAttrs(assetImportAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setShowCancelImportConfirmDialog(false);
        setErrMsgImportAsset(t(translateAPIError(error)));
      }
    });
  }


  return (
    <>

      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Asset_Import_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Asset_Import_Info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <form>
              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Import_req_time")}:</Col>
                <Col>{t("I18N_Import_requester")}:</Col>
                <Col>{t("I18N_Import_status")}:</Col>
                <Col>{t("I18N_Status_update_time")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{formatDate(assetImportAttrs.requestTime)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{assetImportAttrs.requester}</Col>
                <Col>{t("I18N_" + assetImportAttrs.status)}</Col>
                <Col>{formatDate(assetImportAttrs.statusTime)}</Col>
              </Row>

                <>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    <Col>{t("I18N_Import_mode")}:</Col>
                    { assetImportAttrs && assetImportAttrs.importMode === 'IMPORT_SINGLE' ?
                      <Col>{t("I18N_Asset_code")}:</Col>
                    :
                      <Col></Col>
                    }
                    <Col></Col>
                    <Col></Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col>{t("I18N_" + assetImportAttrs.importMode)}</Col>
                    { assetImportAttrs && assetImportAttrs.importMode === 'IMPORT_SINGLE' ?
                      <Col>{assetImportAttrs.assetCode}</Col>
                    :
                      <Col></Col>
                    }
                    <Col></Col>
                    <Col></Col>
                  </Row>
                </>

              { assetImportAttrs && (assetImportAttrs.status === 'ST_CANCELLED') ?
                <>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    <Col>{t("I18N_Import_cancel_time")}:</Col>
                    <Col>{t("I18N_Import_cancel_user")}:</Col>
                    <Col></Col>
                    <Col></Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <Col>{formatDate(assetImportAttrs.cancelTime)}</Col>
                    <Col style={{overflowWrap:'anywhere'}}>{assetImportAttrs.cancelUser}</Col>
                    <Col></Col>
                    <Col></Col>
                  </Row>
                </>
              : null }

              { assetImportAttrs && assetImportAttrs.importError && (assetImportAttrs.importError.length > 0) ?
                <>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    <Col sm={4}>{t("I18N_Asset_import_error")}:</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_value}>
                    <span>{assetImportAttrs.importError}</span>
                  </Row>
                </>
              : null }

              { assetImportAttrs && assetImportAttrs.importMode !== 'IMPORT_SINGLE' ?
                <Row style={{marginTop:'25px'}}>
                  <Col md={2}>
                    { assetImportAttrs && assetImportAttrs.status === 'ST_REQUESTED' ?
                      <Button size="tiny" variant="outline-secondary" className="mb-3"
                        onClick={handleCancelImportRequest}>
                        {t("I18N_Cancel_import_req")}
                      </Button>
                    : null
                    }
                  </Col>
                  <Col md={10}>
                    <span className={classes.admin_pages__field_label} style={{color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsgImportAsset}
                    </span>
                  </Col>
                </Row>
              : null
              }

            </form>
          </Container>
        </div>

        <DeleteConfirmDialog
          title={t("I18N_Cancel_asset_imp_req_confirm")}
          show={showCancelImportConfirmDialog}
          targetName=''
          errMsgDeleteConfirm={errMsgImportConfirm}
          onCancel={handleCancelImportRequestCancel}
          onSubmit={handleCancelImportRequestSubmit}
        />

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                {errMsg}
              </span>
            </div>
          </Form.Group>
        </div>

      </Card>
    </>
  );

}
 
export default AssetImportAdminDetailsView;
